const doc = [({"zh_cn":({"labelHotelWaitingList":({"date":"住宿日期", "email":"邮件地址", "hotelPlanId":"计划", "hotelRoomId":"房型"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;